export default "__VITE_ASSET__CodVUKtx__"